import i18next from "i18next";

 
export   const ValidateFields= {
  competence:   function countInputsValue(searchObject) {
    let i = "";
    var labelsList = [];
    if(searchObject.languageId !== undefined && searchObject.languageId !== 0){
      i++;
      labelsList.push(i18next.t("Language"));
    }
    if(searchObject.languageLevels.length !== 0){
      i++;
      labelsList.push(i18next.t("Level"));
    }
    if(searchObject.skills.length !== 0){
      i++;
      labelsList.push(i18next.t("Skills"));
    }
    if(searchObject.personalSkills){
      let techSkills = searchObject.personalSkills.filter((skill) => skill.rating > 0)
      if(techSkills.length > 0){
        i++;
        labelsList.push(i18next.t("Personal Skills and Competences"));
      }
    }
    if(searchObject.otherSkills !== undefined && searchObject.otherSkills !== ""){
      i++;
      labelsList.push(i18next.t("Other Skills"));
    }

    if(i === ""){
      return i;
    }else{
      return `(${i}) - (${labelsList})`;
    }
  },
  global:   function countInputsValue(searchObject) {
    let i = "";
    var labelsList = [];

    if(searchObject.managerInterestId.length > 0){
      i++;
      labelsList.push(i18next.t("Manager Interest"));
    }
    if(searchObject.jobRoles.length > 0){
      i++;
      labelsList.push(i18next.t("Job Role"));
    }
    if(searchObject.businessAreaId !== 0 && searchObject.businessAreaId !== undefined){
      i++;
      labelsList.push(i18next.t("Business Area"));
    }
    if(searchObject.techAreaId !== 0 && searchObject.techAreaId !== undefined){
      i++;
      labelsList.push(i18next.t("Tech Area"));
    }
    if(searchObject.techRoleId !== 0 && searchObject.techRoleId !== undefined){
      i++;
      labelsList.push(i18next.t("Tech Role"));
    }
    if(searchObject.candidateInterestBusinessAreaId !== 0 && searchObject.candidateInterestBusinessAreaId !== undefined){
      i++;
      labelsList.push(i18next.t("Business Area Interest"));
    }
    if(searchObject.candidateInterestTechAreaId !== 0 && searchObject.candidateInterestTechAreaId !== undefined){
      i++;
      labelsList.push(i18next.t("Tech Area Interest"));
    }
    if(searchObject.candidateInterestTechRoleId !== 0 && searchObject.candidateInterestTechRoleId !== undefined){
      i++;
      labelsList.push(i18next.t("Tech Role Interest"));
    }
    if(searchObject.managerId !== 0 && searchObject.managerId !== undefined){
      i++;
      labelsList.push(i18next.t("Manager"));
    }
    if(searchObject.recommended !== 0 && searchObject.recommended !== undefined){
      i++;
      labelsList.push(i18next.t("Recommended"));
    }
    if(searchObject.rating){
      i++;
      labelsList.push(i18next.t("Rating"));
    }
    if(searchObject.endingDate !== "" && searchObject.endingDate !== undefined){
      i++;
      labelsList.push(i18next.t("End Date"));
    }
    if(searchObject.startingDate !== "" && searchObject.startingDate !== undefined){
      i++;
      labelsList.push(i18next.t("Start date"));
    }
    if(searchObject.addNote !== "" && searchObject.addNote !== undefined){
      i++;
      labelsList.push(i18next.t("Global notes"));
    }
    if(searchObject.tags.length > 0 && searchObject.tags !== undefined){
      i++;
      labelsList.push(i18next.t("Tags"));
    }
    
    if(i === ""){
      return i;
    }else{
      return `(${i}) - (${labelsList})`;
    }
  },
  personal:  function countInputsValue(searchObject) {
    let i = "";
    var labelsList = [];

    if(searchObject.nameOrEmail !== "" && searchObject.nameOrEmail !== undefined){
      i++;
      labelsList.push(i18next.t("Name Or Email"));
    }
    if(searchObject.mobileNumber !== "" && searchObject.mobileNumber !== undefined){
      i++;
      labelsList.push(i18next.t("Mobile number"));
    }
    if(searchObject.zones.length !== 0){
      i++;
      labelsList.push(i18next.t("Zone"));
    }
    if(searchObject.maritalStatusId !== "" && searchObject.maritalStatusId !== undefined){
      i++;
      labelsList.push(i18next.t("Marital Status"));
    }
    if(searchObject.numberOfDependantId !== "" && searchObject.numberOfDependantId !== undefined){
      i++;
      labelsList.push(i18next.t("Nº of dependants"));
    }
    if(searchObject.nationalityId !== "" && searchObject.nationalityId !== undefined){
      i++;
      labelsList.push(i18next.t("Nationality"));
    }
    if(searchObject.countryId !== "" && searchObject.countryId !== undefined){
      i++;
      labelsList.push(i18next.t("Country"));
    }
    if(searchObject.cityId !== "" && searchObject.cityId !== undefined && searchObject.cityId !== null){
      i++;
      labelsList.push(i18next.t("City"));
    }
    if(searchObject.birthDateStart !== "" && searchObject.birthDateStart !== undefined){
      i++;
      labelsList.push(i18next.t("Start date"));
    }
    if(searchObject.birthDateEnd !== "" && searchObject.birthDateEnd !== undefined){
      i++;
      labelsList.push(i18next.t("End Date"));
    }
    if(searchObject.needDocumentation === true){
      i++;
      labelsList.push(i18next.t("Need Documentation"));
    }
    if(searchObject.linkedIn !== "" && searchObject.linkedIn !== undefined){
      i++;
      labelsList.push(i18next.t("LinkedIn"));
    }
    if(searchObject.gitHub !== "" && searchObject.gitHub !== undefined){
      i++;
      labelsList.push(i18next.t("GitHub"));
    }
    
    if(i === ""){
      return i;
    }else{
      return `(${i}) - (${labelsList})`;
    }
  },
  work: function countInputsValue(searchObject) {
    let i = "";
    var labelsList = [];

    if(searchObject.seniorityLevels.length > 0 && searchObject.seniorityLevels !== undefined){
      i++;
      labelsList.push(i18next.t("Seniority Level"));
    }
    if(searchObject.yearsOfExperienceOptions.length > 0 && searchObject.yearsOfExperienceOptions !== undefined){
      i++;
      labelsList.push(i18next.t("Years of Experience"));
    }
    if(searchObject.mainActivities !== "" && searchObject.mainActivities !== undefined){
      i++;
      labelsList.push(i18next.t("Main Activities"));
    }
    if(searchObject.personnalCharacteristics !== "" && searchObject.personnalCharacteristics !== undefined){
      i++;
      labelsList.push(i18next.t("Personal Characteristics"));
    }
    if(searchObject.personalProfile !== "" && searchObject.personalProfile !== undefined){
      i++;
      labelsList.push(i18next.t("Personal Profile"));
    }
    if(searchObject.comments !== "" && searchObject.comments !== undefined){
      i++;
      labelsList.push(i18next.t("Comments"));
    }
    
    if(i === ""){
      return i;
    }else{
      return `(${i}) - (${labelsList})`;
    }
  },
  condition:function countInputsValue(searchObject) {
    let i = "";
    var labelsList = [];

    if(searchObject.AvailabilityStatusId !== 3){
      searchObject.noticeId = undefined;
    }
    if(searchObject.desiredContractTypeId > 0 && searchObject.desiredContractTypeId !== undefined){
      i++;
      labelsList.push(i18next.t("Desired Contract Type"));
    }
    if(searchObject.currentContractTypeId > 0 && searchObject.currentContractTypeId !== undefined){
      i++;
      labelsList.push(i18next.t("Current Contract Type"));
    }
    if(searchObject.remoteWorkId > 0 && searchObject.remoteWorkId !== undefined){
      i++;
      labelsList.push(i18next.t("Remote Work"));
    }
    if(searchObject.mobility){
      if(searchObject.mobility.length > 0){
        i++;
        labelsList.push(i18next.t("Mobility"));
      }
    }
    if(searchObject.AvailabilityStatusId > 0 && searchObject.AvailabilityStatusId !== undefined){
      i++;
      labelsList.push(i18next.t("Availability"));
    }
    if(searchObject.noticeId > 0 && searchObject.noticeId !== undefined){
      i++;
      labelsList.push(i18next.t("Notice"));
    }
    if(searchObject.salaryInformation !== "" && searchObject.salaryInformation !== undefined){
      i++;
      labelsList.push(i18next.t("Salary Information"));
    }
    if((searchObject.upperBoundCurrentSalary !== 0 && searchObject.lowerBoundCurrentSalary !== undefined) || (searchObject.upperBoundCurrentSalary !== 0 && searchObject.upperBoundCurrentSalary !== undefined)){
      i++;
      labelsList.push(i18next.t("Current Salary"));
    }
    if((searchObject.lowerBoundSalary !== 0 && searchObject.lowerBoundSalary !== undefined) || (searchObject.upperBoundSalary !== 0 && searchObject.upperBoundSalary !== undefined)){
      i++;
      labelsList.push(i18next.t("Expected Salary"));
    }
    if(searchObject.exitReason !== "" && searchObject.exitReason !== undefined){
      i++;
      labelsList.push(i18next.t("Exit Reason"));
    }
    if(searchObject.otherProposals !== "" && searchObject.otherProposals !== undefined){
      i++;
      labelsList.push(i18next.t("Other Proposals"));
    }
    if(searchObject.isNegotiable === true){
      i++;
      labelsList.push(i18next.t("Negotiable?"));
    }
    if(searchObject.currentSalaryValueIsLiquid === true){
      i++;
      labelsList.push(i18next.t("Current Salary - Net"));
    }
    if(searchObject.salaryExpectedValueIsLiquid === true){
      i++;
      labelsList.push(i18next.t("Salary Expected - Net"));
    }
    if(searchObject.currentSalaryValueIsLiquid === false){
      i++;
      labelsList.push(i18next.t("Current Salary - Gross"));
    }
    if(searchObject.salaryExpectedValueIsLiquid === false){
      i++;
      labelsList.push(i18next.t("Salary Expected - Gross"));
    }

    if(i === ""){
      return i;
    }else{
      return `(${i}) - (${labelsList})`;
    }
  },
  education: function countInputsValue(searchObject) {
    let i = "";
    var labelsList = [];

    if(searchObject.InstitutionId !== "" && searchObject.InstitutionId !== undefined){
      i++;
      labelsList.push(i18next.t("Institution"));
    }
    if(searchObject.courseId !== "" && searchObject.courseId !== undefined){
      i++;
      labelsList.push(i18next.t("Courses"));
    }
    if(searchObject.courseStartDate !== "" && searchObject.courseStartDate !== undefined){
      i++;
      labelsList.push(i18next.t("Start date"));
    }
    if(searchObject.courseEndDate !== "" && searchObject.courseEndDate !== undefined){
      i++;
      labelsList.push(i18next.t("End Date"));
    }
    if(searchObject.finalClassification !== "" && searchObject.finalClassification !== undefined){
      i++;
      labelsList.push(i18next.t("Final Classification"));
    }
    if(searchObject.notes !== "" && searchObject.notes !== undefined){
      i++;
      labelsList.push(i18next.t("Notes"));
    }
    if(searchObject.onGoing !== undefined){
      i++;
      labelsList.push(i18next.t("Course OnGoing"));
    }
    
    if(i === ""){
      return i;
    }else{
      return `(${i}) - (${labelsList})`;
    }
  },
  applicationDetails: function countInputsValue(searchObject) {
    let i = "";
    var labelsList = [];

    if(searchObject.assignToId !== "" && searchObject.assignToId !== undefined){
      i++;
      labelsList.push(i18next.t("Assign to"));
    }
    if(searchObject.ApplicationDateStart !== "" && searchObject.ApplicationDateStart !== undefined){
      i++;
      labelsList.push(i18next.t("Application Date Start"));
    }
    if(searchObject.ApplicationDateEnd !== "" && searchObject.ApplicationDateEnd !== undefined){
      i++;
      labelsList.push(i18next.t("Application Date End"));
    }
    if(searchObject.candidateSourceId !== "" && searchObject.candidateSourceId !== undefined){
      i++;
      labelsList.push(i18next.t("Source"));
    }
    if(searchObject.recommendedName !== "" && searchObject.recommendedName !== undefined){
      i++;
      labelsList.push(i18next.t("Recommended by name"));
    }
    if(searchObject.recommendedEmail !== "" && searchObject.recommendedEmail !== undefined){
      i++;
      labelsList.push(i18next.t("Recommended by Email"));
    }
    if(searchObject.detailsNotes !== "" && searchObject.detailsNotes !== undefined){
      i++;
      labelsList.push(i18next.t("Notes"));
    }
    if(searchObject.IsCapturedByMeId !== "" && searchObject.IsCapturedByMeId !== undefined){
      i++;
      labelsList.push(i18next.t("Captured by?"));
    }
    
    if(i === ""){
      return i;
    }else{
      return `(${i}) - (${labelsList})`;
    }
  }
}